/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiAttendanceCountTodayGet$Json$Params {
  cycleId?: string;
}

export function apiAttendanceCountTodayGet$Json(http: HttpClient, rootUrl: string, params?: ApiAttendanceCountTodayGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, apiAttendanceCountTodayGet$Json.PATH, 'get');
  if (params) {
    rb.query('cycleId', params.cycleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

apiAttendanceCountTodayGet$Json.PATH = '/api/attendance/count-today';
